import React from 'react';
import PageHeader from './components/PageHeader';
import { DoorbaseTile, DoorbaseTileGrid } from './components/DoorbaseTile';
import { useNavigate } from 'react-router-dom';

function DispatchLanding() {
  const navigate = useNavigate();

  const navItems = [
    { path: '/settings/dispatch-categories', label: 'Dispatch Categories Setup', icon: '📋', description: 'Job and dispatch categories' },
    { path: '/settings/job-status-colors', label: 'Job Status Colors Setup', icon: '🎨', description: 'Configure job status colors' },
    { path: '/settings/sales-order-setup', label: 'Sales Order Setup', icon: '📦', description: 'Statuses and delivery methods' },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <PageHeader
        title="Dispatch Setup"
        subtitle="Dispatch and scheduling configuration"
        backTo="/settings-landing"
        backLabel="Settings"
        sticky
      />

      <main className="max-w-6xl mx-auto px-6 py-8">
        <div className="bg-gray-300 rounded-lg shadow p-6 mx-auto" style={{ width: 'fit-content', maxWidth: '1200px' }}>
          <h2 className="text-xl font-semibold text-gray-800 mb-6">Quick Access</h2>
          <DoorbaseTileGrid columns={3}>
            {navItems.map((item) => (
              <DoorbaseTile
                key={item.path}
                icon={item.icon}
                label={item.label}
                description={item.description}
                onClick={() => navigate(item.path)}
              />
            ))}
          </DoorbaseTileGrid>
        </div>
      </main>
    </div>
  );
}

export default DispatchLanding;
